/* eslint-disable */
import React, { Component } from 'react';
import { Utils, _, Trans } from 'Helpers';
import { Tabs, Tab } from 'react-tabs-scrollable'
import { ReduxHOC } from 'HOC';
class GameweekNativeSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: this.props.SelectedWeek,
      scrollLeftPosition: 0,
      selected_league: Utils.getMultiLeg(),
      init: false
    };
    this.tabRef = null
    this.clickHandler = this.clickHandler.bind(this);
    this.handleRightClick = this.handleRightClick.bind(this);
    this.handleLeftClick = this.handleLeftClick.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.gameweeklastupdate != new Date().valueOf() ) {
      if (!this.state.init) {
        this.setState({
          activeTab: _.findIndex(nextProps.scoring_weeks, (o) => { return o.week == nextProps.SelectedWeek }),
          init: true
        });

      }
    }
  }

  clickHandler = (e, index) => {
    const {
      SelectWeekHandle,
      scoring_weeks
    } = this.props
    this.setState({
      activeTab: index
    },()=>{
      SelectWeekHandle(scoring_weeks[index])
    })
   
  }

  handleRightClick() {
    // const { activeTab } = this.state;
    // const { scoring_weeks } = this.props;
    // const newIndex = activeTab < scoring_weeks.length - 1 ? activeTab + 1 : activeTab;
    // this.setState({ activeTab: newIndex - 1 });
    // this.props.SelectWeekHandle(scoring_weeks[7]);
  }
  
  handleLeftClick() {
    // Implement the logic for the left button click
    // For example, decrementing the activeTab state
    // const { activeTab } = this.state;
    // const { scoring_weeks } = this.props;
    // const newIndex = activeTab > 0 ? activeTab - 1 : activeTab;
    // //this.setState({ activeTab: newIndex-1 });
    // this.props.SelectWeekHandle(scoring_weeks[newIndex-1]);
  }


  render() {
    const {
      scoring_weeks,
      SelectedWeek,
      active_week,
      next_week,
      last_week,
      joined_week,
      is_fixture,
      is_temp,
      i18n,
      selectedWk,
      selectedLeague
    } = this.props
    

    const {
      selected_league,
      activeTab,
    } = this.state

    return (
      <Tabs
        isRTL={i18n.language == "ar"}
        activeTab={activeTab}
        onTabClick={this.clickHandler}
        tabsClassName='gameweek-inner'
        tabsContainerClassName='gameweek-weekslider native-scroll'
        rightBtnIcon={<i className="icon-next" onClick={this.handleRightClick} />}
        leftBtnIcon={<i className="icon-previous" onClick={this.handleLeftClick} />}
      >
        {
          _.map(scoring_weeks, (item, idx) => {
            if (!(item.week <= next_week) && !is_fixture) return '';
            return (
              <Tab key={idx} {...{ className: `week-item${item.week == SelectedWeek || item.week == selectedWk ? ' active' : ''} ${item.is_hide_date == "1" ? 'dis-click' : ''} }` }}>
                <WeekCard
                  {...{
                    item,
                    selected_league,
                    is_temp,
                    active_week,
                    joined_week,
                    next_week,
                    is_fixture,
                    last_week,
                    selectedLeague
                  }} />
              </Tab>
            )
          })
        }
      </Tabs>
    )
  }
}
GameweekNativeSlider.defaultProps = {
  scoring_weeks: [],
  SelectedWeek: null,
  selectedWk: null,
  SelectWeekHandle: () => { },
  gameweeklastupdate: null,
  active_week: null,
  next_week: null,
  last_week: null,
  joined_week: null,
  is_fixture: false,
  is_temp: false, active_week: null
}
export default ReduxHOC(GameweekNativeSlider)


const WeekCard = ({
  item,
  selected_league,
  is_temp,
  active_week,
  joined_week,
  next_week,
  last_week,
  is_fixture,
  selectedLeague
}) => {
 // console.log(selectedLeague,"selectedLeagueselectedLeague");
  
  return (
    <>
      {
        is_temp ?
          <div className="week-label"><Trans>FIFA World Cup 2022</Trans></div>
          :
          <div className="week-label">{selectedLeague ? selectedLeague.week_label[item.week] || item.week : selected_league.week_label[item.week]  || item.week}</div>
      }
      {
        !is_fixture &&
        <div className="week-status">
          {
            (item.week == active_week && (active_week < next_week || active_week == last_week)) &&
            <>
              <b></b>
            </>
          }
          {
            (item.week == next_week && (active_week < next_week || (joined_week == next_week && next_week != active_week) || active_week != last_week)) &&
            <>
              <span><Trans>Upcoming</Trans></span>
            </>
          }
          {
            !(item.week == next_week && (active_week < next_week || (joined_week == next_week && next_week != active_week) || active_week != last_week)) &&
            <>
              <span>{item.total_score}{" "}<Trans>Pts</Trans></span>
            </>
          }
        </div>
      }
    </>
  )

}